import { MarketMarkerComponent } from './market-marker.component';
import { MarketTooltipComponent } from './market-tooltip.component';
import { MarketLegendComponent } from './market-legend.component';

export const MAP_COMPONENTS = [
  MarketMarkerComponent,
  MarketTooltipComponent,
  MarketLegendComponent
];

export {
  MarketTooltipComponent,
  MarketMarkerComponent,
  MarketLegendComponent
};



// WEBPACK FOOTER //
// ./src/app/features/market/components/map/index.ts